import axios from "axios";
import { BaseURL } from "./url";

function client() {
  return axios.create({
    baseURL: BaseURL,
    headers: {
   
    },
  });
}

export default client;
